export const listPolicyDocuments = (client, payload) => client.rpc('service-policy-documents', '1/2021-04-20/get_policy_documents', payload);
export const sendPolicyDocuments = (client, payload) => client.rpc('service-policy-documents', '1/2021-04-20/send_policy_documents', payload);
